import { canUseDOM, getWindow } from '@surfline/web-common';
import { useEffect, useState } from 'react';
import { useTimeoutFn, useUnmount } from 'react-use';

const useJWPlayer = () => {
  const [jwPlayerLoaded, setJwPlayerLoaded] = useState(() => {
    // If the player was already loaded in a previous mount, return true
    if (canUseDOM) {
      const win = getWindow();
      return !!win?.jwplayer;
    }
    return false;
  });

  const [jwPlayerError, setJwPlayerError] = useState('');

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/naming-convention
  const [_isReady, cancel] = useTimeoutFn(
    () => setJwPlayerError('JWPlayer loading timed out'),
    10000,
  );

  useEffect(() => {
    if (jwPlayerLoaded || jwPlayerError) {
      cancel();
    }
  }, [jwPlayerLoaded, jwPlayerError, cancel]);

  // Cancel the timer when we unmount
  useUnmount(() => {
    cancel();
  });

  return {
    jwPlayerLoaded,
    jwPlayerError,
    setJwPlayerLoaded,
    setJwPlayerError,
  };
};

export default useJWPlayer;
